import { useQuery } from '@tanstack/react-query';
import { fetchCostTypes } from '../api/costTypesApi';

export default function useCostTypes() {
    return useQuery({
        queryKey: ['costTypes'],
        queryFn: fetchCostTypes,
    });
}
